<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="150"
    >
      <FormItem label="请上传合并好的视频文件" prop='video_path'>
        <input type="file" accept=".mp4,.mov"  @change="handleVideoFileChange" ref="handleVideoFile"/>
        <label class="search-label">{{show_video_path}}</label>

        <Button type="info" v-if='upload_loadding' :loading="upload_loadding">
              <span>上传中</span>
        </Button>

      </FormItem>

      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'
import moment from 'moment'
import { uploadIdFile, uploadFile } from '@/api/uploadOss'

import config from '@/config'
const { v4: uuidv4 } = require('uuid')
const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro

export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      upload_loadding: false,
      classifyIds: [],
      tagIds: [],
      audioModelIds: [],
      show_advertisement_path: '',
      show_video_path: '',
      update_id: true,
      formValidate: {
        id: '',
        video_path: ''
      },
      ruleValidate: {
        video_path: [
          {
            required: true,
            message: '合并后的视频必须上传',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
    }
  },
  methods: {
    setEditData (params) {
      this.$refs.handleVideoFile.value = ''
      this.formValidate.id = params.id
      this.formValidate.video_path = params.output_video_path
      this.update_id = params.covertFace.covertAudio.translateText.checkSrtTask.shortVideoTask.upload_id

      if (params.output_video_path != null) {
        var video_path_array = params.output_video_path.split('/')
        this.show_video_path = video_path_array[video_path_array.length - 1]
      }
    },
    async handleVideoFileChange (e) {
      try {
        const file = e.target.files[0]
        if (!file) return

        this.formValidate.video_path = await this.uploadFile(file)

        if (this.formValidate.video_path != null) {
          var org_video_array = this.formValidate.video_path.split('/')
          this.show_video_path = org_video_array[org_video_array.length - 1]
        }
      } catch (error) {
        this.$Message.error('上传失败')
        this.$refs.handleVideoFile.value = ''
      }
    },
    async uploadFile (file) {
      this.upload_loadding = true
      // 上传文件
      let currentDate = moment().format('YYYY-MM-DD')
      const uuid = uuidv4()
      var name = file.name.substring(file.name.lastIndexOf('.'))
      var result = ''
      if (baseUrl == 'https://in.sinano-ai.com/api') {
        result = await uploadIdFile('short_video/' + currentDate + '/covert_audio/' + uuid + name, file)
      } else {
        result = await uploadFile('short_video/' + currentDate + '/covert_audio/' + uuid + name, file)
      }
      if (result == '') {
        this.$Message.error('上传失败')
        this.$refs.handleVideoFile.value = ''
      } else {
        this.$Message.info('上传成功')
      }

      this.upload_loadding = false

      return result
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
  }
}
</script>
